import React from 'react'
import {
  IProps as ICustomerStoryHero,
  CustomerStoryHero,
} from 'marketing-site/src/library/components/CustomerStoryHero'
import { ICustomerStoryHero as IContentfulCustomerStoryHero } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { transformImage } from '../elements/ContentfulImage'

export const ContentfulCustomerStoryHero = (data: IContentfulCustomerStoryHero) => {
  return (
    <EntryMarker entry={data}>
      {() => <CustomerStoryHero {...transformCustomerStoryHero(data)} />}
    </EntryMarker>
  )
}

export function transformCustomerStoryHero({
  fields,
}: IContentfulCustomerStoryHero): ICustomerStoryHero {
  return {
    ...fields,
    image: fields.image && transformImage(fields.image),
    video: fields.video?.fields.file.url,
  }
}
